
import { mapState } from "vuex";
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

export default {
components: {
Tabbar,
TabbarItem
},
data() {
return {
curTab: ""
};
},
computed: {
...mapState(["showTabbar", "showTabbarIndex"]),
returnShowTabBarIndex: {
get() {
return parseInt(this.showTabbarIndex);
},
set() {}
}
},
watch: {

$route(to, from) {
if (to.path == "/home") {

this.$store.commit("SHOWTABBAR", "0");
this.curTab = 0;
} else if (to.path == "/productList") {

this.$store.commit("SHOWTABBAR", "1");
this.curTab = 1;
if (JSON.parse(sessionStorage.getItem('auth_Key'))) {
this.$store.commit("HIDETABBAR");
}
} else if (to.path == "/me") {

this.$store.commit("SHOWTABBAR", "2");
this.curTab = 2;
} else if (to.path == "/more") {

this.$store.commit("SHOWTABBAR", "3");
this.curTab = 3;
} else {

this.$store.commit("HIDETABBAR");
}
}
},
methods: {
menuClick(data) {
sessionStorage.setItem('auth_Key', false);
this.curTab = data;
}
}
};



// WEBPACK FOOTER //
// ./src/components/Bottom.vue